//@flow
import { combineReducers } from 'redux'

import client from './client/reducer'
import learner from './learner/reducer'
import questions from './questions/reducer'
import quiz from './quiz/reducer'

const rootReducer = combineReducers({
  client,
  learner,
  questions,
  quiz,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/state/reducer.js